import React from 'react';
import ReactModal from 'react-modal';
import { ModalSC } from './modal.styled';

// @ts-nocheck

type TModalProps = {
  showClose?: boolean;
  zIndex?: number;
  children?: React.ReactNode;
  onRequestClose?: () => void;
} & ReactModal.Props;

const Modal: React.FC<TModalProps> = ({
  children,
  zIndex,
  style,
  showClose,
  ...props
}: TModalProps) => {
  const styles: any = {
    ...style,
    overlay: {
      ...style?.overlay,
      display: 'flex',
      overflow: 'auto',
      zIndex: zIndex || 999,
      background: 'rgba(255,255,255,.8)',
    },
  };
  return (
    <ReactModal
      {...props}
      style={styles}
      // @ts-ignore
      parentSelector={() => document.querySelector('#modal')}
    >
      <ModalSC>
        {showClose && (
          <button className="modal-close" onClick={props.onRequestClose}>
            <img src={require('../../assets/svg/icon-cross-black.svg').default} alt="Close" />
          </button>
        )}
        {children}
      </ModalSC>
    </ReactModal>
  );
};

Modal.defaultProps = {
  bodyOpenClassName: 'body-modal-open',
  shouldCloseOnOverlayClick: true,
  onRequestClose: () => {},
  ariaHideApp: false,
  style: {
    content: {
      padding: 0,
      position: 'static',
      margin: 'auto',
      border: 'none',
      background: '#fff',
      boxShadow: '0 2px 15px 0 rgba(51,61,108,0.1)',
      borderRadius: 24,
    },
  },
};

export default Modal;
